import React, { useEffect, useState } from "react";
// import { pendingTask } from "../../utils/proxy/AttendanceProxy";
import { useLocation } from 'react-router-dom'

export const CustomToolbar = ({ isHoliday, handledelete, setShowAddHoliday, refreshPending, setReload, ...toolbar }) => {

  // const [pendingTasks, setPendingTasks] = useState([]);
  const { state } = useLocation();
  // const [loading, setLoading] = useState(false);
  // const [selectedUserId, setSelectedUserId] = useState((localStorage.getItem('role') === 'User' || state != null) ? localStorage.getItem('uuid') : null);

  const goToBack = () => toolbar.onNavigate('PREV');
  const goToNext = () => toolbar.onNavigate('NEXT');
  const goToToday = () => toolbar.onNavigate('TODAY');

  const handleMakeHoliday = () => {
    setShowAddHoliday(true);
  };

  //  const fetchPendingtask = async () => {
  //       try {
  //           if (!selectedUserId) return;
  //           setLoading(true);
  //           const tasks = await pendingTask(selectedUserId);
  //           if (tasks) {
  //               setPendingTasks(tasks)
  //           }
  //       } catch (err) {
  //           console.error("Error fetching pending tasks:", err);
  //       } finally {
  //           setLoading(false)
  //       }
  //       setReload(true)
  //   }

    // useEffect(() => {
    //     fetchPendingtask();
    //     const interval = setInterval(() => {
    //         fetchPendingtask();
    //     }, 10000); // refresh every 30 sec

    //     return () => clearInterval(interval);

    // }, [selectedUserId,refreshPending]);

  const role = localStorage.getItem('role')?.toLowerCase();
  const showCustomButton =
    (role === 'admin') &&
    toolbar.view === 'day';

  return (
    <div className="rbc-toolbar">
      <span className="rbc-btn-group">
        <button onClick={goToBack}>Back</button>
        <button onClick={goToToday}>Today</button>
        <button onClick={goToNext}>Next</button>
      </span>

      <span className="rbc-toolbar-label">{toolbar.label}</span>

      {/* <div className="dropdown">
        <button className="btn btn-warning dropdown-toggle" data-bs-toggle="dropdown">
          Pending Tasks ({pendingTasks.length})
        </button>

        <ul className="dropdown-menu">
          {loading && <li className="dropdown-item">Loading...</li>}

          {!loading && pendingTasks.length === 0 && (
            <li className="dropdown-item text-muted">No Pending Tasks</li>
          )}

          {pendingTasks.map((item, index) => (
            <li key={index} className="dropdown-item">
              <strong>{item.task.task}</strong>
              <br />
              <small>Action: {item.action}</small>
            </li>
          ))}
        </ul>
      </div> */}

      <span className="calendar-views rbc-btn-group">
        {['month', 'week', 'day', 'agenda'].map((view) => (
          <button
            key={view}
            onClick={() => toolbar.onView(view)}
            className={toolbar.view === view ? 'active' : ''}
          >
            {view.charAt(0).toUpperCase() + view.slice(1)}
          </button>
        ))}
        {showCustomButton && isHoliday ? (
          <button onClick={handledelete} className="delete-holiday-btn">
            Delete Holiday
          </button>
        ) : showCustomButton && !isHoliday ? (
          <button onClick={handleMakeHoliday} className="make-holiday-btn">
            Make Holiday
          </button>
        ) : null}
      </span>
    </div>
  );
};